import {
  FilesPreviewGallery,
  useFilePreviewGallery,
} from '../../FilesPreviewGallery'
import { BirdviewCard } from '../BirdviewCard'
import { BirdviewDocumentRow } from '../BirdviewDocumentRow'
import { BIRDVIEW_SECTION_TARGET } from '../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'

function BirdviewDocumentsWidget({
  dragHandleProps,
  section,
  title,
  onNavigate,
}) {
  const { getListTarget } = useBirdviewListTarget()

  const files = section.items.map(item => item.file)

  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({ files })

  function handleShowAll(event) {
    onNavigate({
      event,
      link: getListTarget(BIRDVIEW_SECTION_TARGET.dwellerDocuments),
    })
  }

  function handleOpen({ item }) {
    handleClickFile(item.id)
  }

  return (
    <>
      <BirdviewCard
        count={section.total}
        dragHandleProps={dragHandleProps}
        hasMore={section.hasMore}
        isRefreshing={section.isRefreshing}
        state={section.state}
        title={title}
        onRetry={section.reload}
        onShowAll={handleShowAll}
      >
        {section.items.map(item => (
          <BirdviewDocumentRow item={item} key={item.id} onOpen={handleOpen} />
        ))}
      </BirdviewCard>
      <FilesPreviewGallery
        files={files}
        initActive={activeFileIndex}
        onClose={handleCloseFilePreview}
      />
    </>
  )
}

export default BirdviewDocumentsWidget
